var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Nav',{attrs:{"title":'在线咨询'}})
}
var staticRenderFns = []

export { render, staticRenderFns }